import {createGlobalStyle} from "styled-components";

const GlobalStyle = createGlobalStyle`
  *,*::after,*::before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
  }

  body {
    line-height: 1.7;
    overflow-x:hidden;
  }

  a, button, input {
    outline: none;
  }

  .mobile-only {
    display: none;
  }

  a {
    display: inline-block;
    color: black;
    text-decoration: none;
    font-size: 1.6rem;
    font-family: 'Avenir-Book';
    font-display: swap;
  }

  .main {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    width: 100vw;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  .header {
    grid-column: 1 / -1;
    grid-row: 1 / 2;
  }

  ul {
    list-style-type: none;
  }

  .hyperlink--blue,
  .hyperlink--pink {
    text-decoration: none;
    font-size: inherit;

    &:hover {
      text-decoration: underline;
    }
  }

  .hyperlink--blue {
    color: #0098f7;
  }

  .hyperlink--pink {
    color: #d93764;
  }

  .transform-unset {
    transform: unset!important;
  }

  @media (min-width : 112.5em) {
    html {
      font-size : 75%;
    }
  }

  @media (max-width : 75rem) {
    html {
      font-size : 56.25%;
    }
  }

  // MOBILE STYLING

  @media (max-width: 37.5em) {

    .desktop-only {
      display: none;
    }

    .mobile-only {
      display: block;
    }
  }
`;

export default GlobalStyle;
